// @flow

import langmap from 'langmap'
import { pathOr } from 'ramda'

export const getLanguageNativeNameByKey = (key: string, defaultValue: string = '') =>
  pathOr(defaultValue, [key, 'nativeName'], langmap)
